import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameOfFile'
})
export class NameOfFilePipe implements PipeTransform {

  transform(value: string, args?: any): string {
    if(value !=null){
       let  filename:string =value.substring(value.lastIndexOf('\\')+1);
     
    return filename;
    }
    else{
      return null;
    }
}

}
